import { card, cardHover, tag, tagHi } from "@/lib/styles";

// Shared card for rendering one platform's verified facts consistently across
// both comparison pages, so the two pages can't quietly drift out of sync.
export default function CompetitorCard({ competitor, isPromptbound }) {
  const c = competitor;
  return (
    <div className={`${card} ${cardHover} p-6 sm:p-7`}>
      <div className="flex flex-wrap items-center gap-2 justify-between">
        <h3 className="font-serif font-bold text-xl text-zinc-100">{c.name}</h3>
        {isPromptbound && <span className={tagHi}>This is us</span>}
      </div>
      <p className="mt-1 text-xs text-zinc-500">{c.bestFor}</p>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <span className="text-[11px] uppercase tracking-[0.2em] text-gold font-semibold">Price</span>
          <p className="mt-1 text-sm text-zinc-300 leading-relaxed">{c.priceDetail}</p>
        </div>
        <div>
          <span className="text-[11px] uppercase tracking-[0.2em] text-gold font-semibold">Reviews</span>
          <p className="mt-1 text-sm text-zinc-300 leading-relaxed">{c.reviewsDetail}</p>
        </div>
      </div>

      <p className="mt-4 text-sm text-zinc-400 leading-relaxed border-t border-zinc-800 pt-4">{c.note}</p>

      <div className="mt-3">
        <span className={tag}>{c.priceShort}</span> <span className={tag}>{c.reviewsShort}</span>
      </div>
    </div>
  );
}
